import { union, without } from 'lodash';
import { createWithEqualityFn as create } from 'zustand/traditional';

interface ScrollTopContext {
    exclude: string[];
    registerExclusion: (paths: string[]) => void;
    unRegisterExclusion: (paths: string[]) => void;
}

const useScrollTopManager = create<ScrollTopContext>(set => ({
    exclude: [],
    registerExclusion: paths => set(state => ({ exclude: union([...state.exclude, ...paths]) })),
    unRegisterExclusion: paths => {
        set(state => {
            return { exclude: without(state.exclude, ...paths) };
        });
    },
}));

export { useScrollTopManager };
